import { render, staticRenderFns } from "./customSelect.vue?vue&type=template&id=3403f5d1&scoped=true&"
import script from "./customSelect.vue?vue&type=script&lang=js&"
export * from "./customSelect.vue?vue&type=script&lang=js&"
import style0 from "./customSelect.vue?vue&type=style&index=0&id=3403f5d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3403f5d1",
  null
  
)

export default component.exports